import { combineReducers } from "redux";
// import reducer from "./reducer";
import userReducer from "./reducer/userReducer";
import workbookReducer from "./reducer/workbookReducer";
import sheetReducer from "./reducer/sheetReducer";
import currentSheetDataReducer from "./reducer/currentSheetDataReducer";
import userActivityReducer from "./reducer/userActivityReducer";
import workspaceReducer from "./reducer/workSpaceReducer";
import templateReducer from "./reducer/templateReducer";
import rowCopyPasteReducer from "./reducer/rowCopyPasteReducer";
// import undoRedoReducer from "./reducer/UndoRedoReducer";

const rootReducer = combineReducers({
    // reducer,
    userReducer,
    workbookReducer,
    sheetReducer,
    currentSheetDataReducer,
    userActivityReducer,
    workspaceReducer,
    templateReducer,
    rowCopyPasteReducer,
    // undoRedoReducer,
})

export default rootReducer;
